import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check the presence of a token in localStorage
  const isAuthenticated = !!localStorage.getItem("adminToken"); 

  if (!isAuthenticated) {
    // If not authenticated, redirect to the home page.
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
